import { Pipe, PipeTransform } from '@angular/core';

/*
 * Convert bytes into largest possible unit.
 * Takes an precision argument that defaults to 2.
 * Usage:
 *   bytes | fileSize:precision
 * Example:
 *   {{ 1024 |  fileSize}}
 *   formats to: 1 KB
 *
 * https://gist.github.com/JonCatmull/ecdf9441aaa37336d9ae2c7f9cb7289a
*/
@Pipe({
  name: 'fileSize',
  standalone: true,
})
export class FileSizePipe implements PipeTransform {
  private units: string[] = [
    'bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB',
  ];

  /**
   * formats a given fileSize
   */
  public transform(bytes: number = 0, precision: number = 2): string {
    if (Number.isNaN(parseFloat(String(bytes))) || !Number.isFinite(bytes)) {
      return '?';
    }

    let unit = 0;
    let parsedBytes = bytes;

    while (parsedBytes >= 1024) {
      parsedBytes /= 1024;
      unit += 1;
    }

    return `${parsedBytes.toFixed(+precision)} ${this.units[unit]}`;
  }
}
